import { entityLabelMatcher } from '../helpers/label-mapper';

const DefinitionMapper = (entityType, label) => {
  entityType = entityLabelMatcher(entityType, 'singular').toLocaleLowerCase();

  switch (label) {
    case 'revenue':
      return `Income generated from ${
        entityType === 'organisation' ? 'an' : 'a'
      } ${entityType}'s activities.`;
    case 'expenses':
      return `Payments required to deliver ${
        entityType === 'organisation' ? 'an' : 'a'
      } ${entityType}'s activities.`;
    case 'assets':
      return `A resource ${
        entityType === 'organisation' ? 'an' : 'a'
      } ${entityType} controls that will provide a future benefit (for example, cash, land and buildings).`;
    case 'currentAssets':
      return 'An asset that is available for use, or is expected to be consumed in a short time, usually 12 months (for example cash).';
    case 'nonCurrentAssets':
      return 'An asset that is not a current asset (for example land and buildings)';
    case 'liabilities':
      return `${
        entityType === 'organisation' ? 'An' : 'A'
      } ${entityType}'s obligations to make future payments (for example, payables, borrowings and employee entitlements).`;
    case 'currentLiabilities':
      return 'A liability that may be required to be settled in a short time, usually 12 months (for example payables due in 30 days).';
    case 'nonCurrentLiabilities':
      return 'A liability that is not a current liability (for example long-term borrowings).';
    case 'ppEAdditions':
      return `Property, plant and equipment additions are the additions to property, plant and equipment per the entity's 2021 financial statements`;
    case 'year2019StudentStaffRatioEftslFte':
      return `The student/staff ratio provides the number of students (at an EFTSL level) per staff member (at FTE level). Staff includes teaching and support staff and does not include staff employed by third party providers (that some universities may utilise to deliver courses)`;
    default:
      return '';
  }
};

export default DefinitionMapper;



// WEBPACK FOOTER //
// ./src/helpers/definition-mapper.js